import React from "react";
import { Skeleton, useMediaQuery, useTheme } from "@mui/material";

const MapSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className="w-full bg-white">
      <div className="flex items-center border-b-2 border-gray-200 px-4 py-3">
        <Skeleton variant="text" width={isMobile ? 180 : 240} height={28} />
      </div>

      <div
        className={`relative w-full bg-gray-100 ${
          isMobile ? "h-[450px]" : "h-[500px]"
        }`}
      >
        <div className="absolute left-0 right-0 top-0 z-[1] flex justify-between gap-2 p-2">
          <div className="flex items-center gap-2 rounded-md bg-gray-200 p-2">
            <Skeleton
              variant="rounded"
              width={isMobile ? 140 : 200}
              height={36}
            />
            <Skeleton variant="rounded" width={72} height={36} />
          </div>

          {!isMobile && (
            <Skeleton variant="rounded" width={280} height={44} />
          )}
        </div>

        {isMobile && (
          <div className="absolute left-2 right-2 top-[60px] z-[1] rounded-md bg-gray-200 p-2">
            <Skeleton variant="rounded" width="100%" height={36} />
          </div>
        )}
      </div>

      <div className="mt-3 px-2 pb-2">
        <Skeleton variant="rounded" height={42} sx={{ mb: 0.5 }} />
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton
            key={`map-table-row-${index}`}
            variant="rounded"
            height={52}
            sx={{ mb: 0.5 }}
          />
        ))}
      </div>
    </div>
  );
};

export default MapSkeleton;
